import { createFileRoute } from "@tanstack/react-router";
import { NutritionPage } from "@/modules/nutrition/presentation/pages/NutritionPage";

export const Route = createFileRoute("/_authenticated/nutrition")({
  component: NutritionPage,
});
